export default __webpack_public_path__ + "static/media/streetview.35cdd496.png";